/**
 *
 * @param {String} selector
 */
export default function stopEmbeddedVideos(selector) {
  const iframes = document.querySelectorAll(selector)

  iframes.forEach((iframe) => {
    iframe.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*')
  })
}